import * as React from 'react';
import { useEffect, useState } from 'react';
import { List, ListItem, ListItemAvatar, ListItemText, Box, Divider, Typography } from '@mui/material';
import { ThemeClient } from '../contexts/Theme'
import Logo from '../components/Logo'
import Navbar from '../Navbar'

import { supabase } from '../supabaseClient';

import { useAuth } from '../contexts/auth'
import { useCode } from '../contexts/Code';
import { useCompany } from '../contexts/Company';

import Avatar from '../components/Avatar';
import Navegation from '../components/Navegation'

export default function Ranking() {
  const [rankingData, setRankingData] = useState(null);
  const [profile, setProfile] = useState(null);

  const { user } = useAuth()
  const { code } = useCode()
  const company = useCompany()

  async function fetchProfile() {
    console.log(user)
    var { data: profile, error } = await supabase
      .from('users')
      .select('*')
      .eq('id', user?.id)
      .eq('company', code)
      .single()

    setProfile(profile)
  }

  async function fetchRankingData() {
    if (company?.demo) {
      setRankingData([
        { name: 'John Doe', score: 2400 },
        { name: 'Daniela Orange', score: 1800 },
        { name: 'Lara Oliveira', score: 1600 },
        { name: 'Lara Orange', score: 1200 },
        { name: 'Luana Inicial', score: 800 },
        { name: 'Rose Oliveira', score: 400 },
        { name: 'Henrique', score: 300 }
      ])
    } else {
      var { data: ranking, error } = await supabase
        .from('users')
        .select('*')
        .eq('company', code)
        .order('score', { ascending: false })

      if (error) {
        console.error('Error fetching ranking data:', error);
      } else {
        setRankingData(ranking);
      }
    }
  }

  useEffect(() => {
    fetchRankingData();
    fetchProfile();
  }, [company]);

  if (!company) return <></>

  return (
    <ThemeClient>
      <Navbar title={'Ranking'} />
      <Logo
        style={{
          height: 'auto',
          maxWidth: '100%',
          marginTop: '2rem',
          marginBottom: '2rem',
        }}
      />
      <Box
        sx={{
          marginTop: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Divider light />

        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
          {rankingData && rankingData.map((rankingUser, index) => {
            if (rankingUser.id === user?.id) {
              return null; 
            }
            return (
              <React.Fragment key={index}>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar userId={rankingUser?.id}/>
                  </ListItemAvatar>
                  <ListItemText primary={
                    <Typography 
                      variant="body2" style={{ color: '#FFFFFF' }}>
                      {company.id === 45 ? rankingUser.name.split('@')[0] : rankingUser.name}</Typography>} 
                      secondary={`${rankingUser.score} puntos`} 
                      sx={{ color: 'white' }} />
                </ListItem>                
                <Divider light />
              </React.Fragment>
            );
          })}
        </List>
      </Box>
      <Navegation />
    </ThemeClient>
  );
}
